<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>교재별설정 통계</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">통계관리</a>
        </li>
        <li class="breadcrumb-item active">교재별설정 통계</li>
      </ol>
    </div>
    <!-- 검색 -->
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="조회기간" :data="data" @search="search" @reset="reset" />
        </div>
        <div class="form-row align-items-center">
            <!-- 항목 검색 -->
            <b-button-group class="ml-4">
              <button @click="search()" class="btn btn-primary mb-2"><i class="fa fa-search"></i>Search</button>
              <button @click="reset()" class="btn btn-secondary mb-2">Clear</button>
            </b-button-group>
        </div>
      </div>
    </div>
    <!-- 검색 -->

    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">교재별설정 순위</span>
        <div class="card-tool float-right" >
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="excelDownload()" >엑셀 다운로드</b-btn>
        </div>
        <ShowCounter label="Show" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td style="text-align:center">번호<em class="fa-2s mr-2 fas"></em></td>
            <td style="text-align:center">교재명<em class="fa-2s mr-2 fas"></em></td>
            <td style="text-align:center">저자<em class="fa-2s mr-2 fas"></em></td>
            <td style="text-align:center">설정수<em class="fa-2s mr-2 fas"></em></td>
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center">
            <td colspan="9">No matching records</td>
          </tr>
          <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index"  >
            <td class="align-middle text-center">{{item.seq}}</td>
            <td class="align-middle text-center">{{item.textbookNm}}</td>
            <td class="align-middle text-center">{{item.author}}</td>
            <td class="align-middle text-center">{{item.setCnt}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- 목록 -->
  </ContentWrapper>
</template>

<script>
import { onMounted, reactive, ref, computed } from '@vue/composition-api';
import {dataObject} from '@/utils/Constants';
import {getTextbookSetList, getTextbookSetListExcelDownload} from "@/api/stats/TextbookAdoptApi"
import Pagenation from '@/components/Common/Pagenation'
import SchDateRange from '../../components/Common/SchDateRange'
import ShowCounter from '../../components/Common/ShowCounter'
import LabelSelect from '../../components/Common/LabelSelect'
import { TableActionClass } from '@/utils/TableActionClass';
import store from "@/store/index";

export default {
  components: {SchDateRange, ShowCounter, Pagenation, LabelSelect},

  setup() {
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject);

    /////////////////
    const loadData = () => { store.dispatch('StatFilter/resetFilter') }

    const fileRemove = () =>{
      data.row.url = null;
    }

    onMounted(loadData);

    return{
      dataObject,
      _dataObject,
      data,
      fileRemove,      
      ...methods(),
      dataAction: new TableActionClass(data),
    }
  }
}

function methods() {
  var context = {};
  context['getTextbookSetList'] = getTextbookSetList;

  async function search() {
    let _params = this.data.params;
    await this.dataAction.execute("getTextbookSetList",context,_params);
    this.fileRemove();
  }
  async function reset() {
    this.data.params.mode = "list";
  }
  async function excelDownload() {
    let _params = this.data.params;
    await getTextbookSetListExcelDownload(_params, '교재별설정통계');
  }

  return {
    search,
    reset,
    excelDownload
  }
}
</script>
